var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[(_vm.catalog.document)?_c('simple-text',{attrs:{"content":_vm.catalog.document.clientOriginalFileName}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }